<template>
  <div>
    <div>
      <div class="grid">
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("First name") }}:</span>
          <p-vue-input-text v-model="contactLocal.FirstName" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Last name") }}:</span>
          <p-vue-input-text v-model="contactLocal.LastName" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Mobile") }}:</span>
          <p-vue-input-text v-model="contactLocal.TelMobile" />
          <i-form-error :data="errors.TelMobile" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Mobile") }} 2:</span>
          <p-vue-input-text v-model="contactLocal.TelMobile2" />
          <i-form-error :data="errors.TelMobile2" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Email") }}:</span>
          <p-vue-input-text v-model="contactLocal.Email" />
          <i-form-error :data="errors.Email" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Email") }} 2:</span>
          <p-vue-input-text v-model="contactLocal.Email2" />
          <i-form-error :data="errors.Email2" />
        </div>
      </div>
    </div>
    <div class="p-d-flex p-jc-between p-mt-4">
      <p-vue-button
        class="button p-button-rounded p-button-success"
        :label="__('Save')"
        @click="save"
      />
      <p-vue-button
        class="button p-button-rounded p-button-success"
        :label="__('Cancel')"
        @click="close"
      />
    </div>
  </div>
</template>

<script>
import { __ } from "@/plugins/i18n";
import { apiParam, apiPType, callProc } from "@/services/APointAPI";
import {
  errorReceived,
  isValidEmail,
  isValidPhoneNumber,
  showSuccessOrFailedModal,
} from "@/services/apointUtil";
import { mapState } from "vuex";
export default {
  props: {
    contact: Object,
    close: Function,
  },
  emits: ["ContactUpdate"],
  data() {
    return {
      contactLocal: {},
      errors: {
        Email: null,
        Email2: null,
        TelMobile: null,
        TelMobile2: null,
      },
      valid: true,
    };
  },
  mounted() {
    this.contactLocal = this.contact;
  },
  methods: {
    validateFields() {
      this.valid = true;
      this.errors = {
        Email: null,
        Email2: null,
        TelMobile: null,
        TelMobile2: null,
      };
      if (this.contactLocal.Email && !isValidEmail(this.contactLocal.Email)) {
        this.valid = false;
        this.errors.Email = "Invalid email address";
      }
      if (this.contactLocal.Email2 && !isValidEmail(this.contactLocal.Email2)) {
        this.valid = false;
        this.errors.Email2 = "Invalid email address";
      }

      if (
        this.contactLocal.TelMobile &&
        !isValidPhoneNumber(this.contactLocal.TelMobile)
      ) {
        this.valid = false;
        this.errors.TelMobile = "Invalid phone number";
      }
      if (
        this.contactLocal.TelMobile2 &&
        !isValidPhoneNumber(this.contactLocal.TelMobile2)
      ) {
        this.valid = false;
        this.errors.TelMobile2 = "Invalid phone number";
      }
    },
    save() {
      this.validateFields();
      if (!this.valid) return;
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("ContactID", this.contactLocal.ContactID, apiPType.Int),
        apiParam("FirstName", this.contactLocal.FirstName, apiPType.NVarChar),
        apiParam("LastName", this.contactLocal.LastName, apiPType.NVarChar),
        apiParam("TelMobile", this.contactLocal.TelMobile, apiPType.NVarChar),
        apiParam("TelMobile2", this.contactLocal.TelMobile2, apiPType.NVarChar),
        apiParam("Email", this.contactLocal.Email, apiPType.NVarChar),
        apiParam("Email2", this.contactLocal.Email2, apiPType.NVarChar),
      ];
      callProc("WorkerApp_UpdateContact", procParams)
        .then((result) => {
          result = JSON.parse(result);
          if (result.procReturnValue == 0) {
            showSuccessOrFailedModal(__("Data saved successfully!"));
          } else {
            showSuccessOrFailedModal(__("An error occurred"), false);
          }
          setTimeout(() => {
            this.close();
          }, 2000);
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_UpdateContact");
        });
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
  },
};
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: 48% 48%;
  justify-content: space-between;
}
</style>
